import { success } from '../../util/Response';
import fetch from 'isomorphic-fetch';
import { SITE_URL } from '../../../../config/environment';

const fetchData = async ({ location }) => {
    const { pathname } = location;
    const parts = pathname.replace('/sitemap/', '').split('/');
    const category = parts[0];
    const page = parts.length > 1 ? parts[1] : '';
    const file = `sitemap${category.length ? `-${category}` : ''}${page.length ? `-${page}` : ''}.json`
        
    try {
        const response = await fetch(`https://nearbites.com/sitemap/${file}`)

        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        
        const json = await response.json();
        
        return Promise.resolve(success(json));

    } catch (error) {
        return Promise.reject(error.message);
    }
};

export default fetchData;
